<template>
  <div id="colours">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="swatches col-sm-6">
            <div class="slate-500 swatch-title">
              <h3>slate</h3>
            </div>
            <span class="color-swatch slate-100">100</span>
            <span class="color-swatch slate-200">200</span>
            <span class="color-swatch slate-300">300</span>
            <span class="color-swatch slate-400">400</span>
            <span class="color-swatch slate-500">500</span>
            <span class="color-swatch slate-600">600</span>
            <span class="color-swatch slate-700">700</span>
            <span class="color-swatch slate-800">800</span>
          </div>
          <div class="swatches col-sm-6">
            <div class="blue-500 swatch-title">
              <h3>blue</h3>
            </div>
            <span class="blue-100 color-swatch">100</span>
            <span class="blue-200 color-swatch">200</span>
            <span class="blue-300 color-swatch">300</span>
            <span class="blue-400 color-swatch">400</span>
            <span class="blue-500 color-swatch">500</span>
            <span class="blue-600 color-swatch">600</span>
            <span class="blue-700 color-swatch">700</span>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6">
            <div class="swatches">
              <div class="light-blue-500 swatch-title">
                <h3>light-blue</h3>
              </div>
              <span class="color-swatch light-blue-100">100</span>
              <span class="color-swatch light-blue-500">500</span>
              <span class="color-swatch light-blue-900 text-white">900</span>
            </div>
          </div>
          <div class="swatches col-sm-6">
            <div class="red-500 swatch-title">
              <h3>red (500)</h3>
            </div>
            <span class="color-swatch red-100">100</span>
            <span class="color-swatch red-500">500</span>
            <span class="color-swatch red-900 text-white">900</span>
          </div>
          <div class="swatches col-sm-6">
            <div class="green-500 swatch-title">
              <h3>green (500)</h3>
            </div>
            <span class="color-swatch green-100">100</span>
            <span class="color-swatch green-500 text-white">500</span>
            <span class="color-swatch green-900 text-white">900</span>
          </div>
          <div class="swatches col-sm-6">
            <div class="orange-500 swatch-title">
              <h3 class="text-dark">orange</h3>
            </div>
            <span class="color-swatch orange-100">100</span>
            <span class="color-swatch orange-500">500</span>
            <span class="color-swatch orange-900 text-white">900</span>
          </div>
        </div>
      </div>
    </div>
    <p
      class="mt-5 text-16"
    >The color palette comes with 9 different weights for each hue, ranging from 100 (lightest) to 900 (darkest.) When using colors start with the 500 weight then go up or down in weight.</p>
    <article>
      <p
        class="mt-5"
      >Colors should have a semantic value when used in an interface. Stick with these rules:</p>
      <ul>
        <li>Use blue for “Go” actions like “Sign Up,” “Send,” or “Comment”.</li>
        <li>Use red for “Danger” actions like deleting or removing.</li>
        <li>Use orange for “Waiting” things like loading, warnings, or non-critical errors.</li>
      </ul>
    </article>
  </div>
</template>

<script>
import BSN from 'bootstrap.native/dist/bootstrap-native-v4'
let title = 'Colour Palettes'
let tagline = 'Colour palettes for our UI design that work harmoniously with our brand colours. It’s also very important to adhere to the accessibility guidelines.'

export default {
  name: 'colours',
  beforeCreate: function () {
    this.$emit('update-title', title) 
    this.$emit('update-tagline', tagline) 
  },
  mounted: function () {
    let createCopyClipboardClick = elements => {
      elements.forEach(element => {
        // Get hex colour code from css property 'content' and add popover
        let hexColourCode = getComputedStyle(element, ':before').content
        hexColourCode = hexColourCode.replace(/"/g, '').toUpperCase()
        element.setAttribute('data-content', `Copy "${hexColourCode}" to clipboard`)
        new BSN.Popover(element, {
          placement: 'right',
          trigger: 'hover',
          container: 'body',
        })
        element.addEventListener('click', this.copyHexColourCodeToClipboard)
      })
    }

    let swatchTitles = document.getElementsByClassName('swatch-title')
    let swatches = document.getElementsByClassName('color-swatch')
    createCopyClipboardClick([...swatchTitles])
    createCopyClipboardClick([...swatches])
  },
  methods: {
    copyHexColourCodeToClipboard: function (event) {
      let eventElement = event.target
      let divEventElement
      if (eventElement.nodeName === "H3") {
        divEventElement = eventElement.parentNode
      } else {
        divEventElement = eventElement
      }
      // Copy hex colour code to clipboard
      // Code from https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
      let hexColourCode = getComputedStyle(divEventElement, ':before').content
      hexColourCode = hexColourCode.replace(/"/g, '').toUpperCase()
      const el = document.createElement('textarea');
      el.value = hexColourCode;
      el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
      el.style.left = '-9999px';                      // Move outside the screen to make it invisible
      document.body.appendChild(el);
      const selected =            
        document.getSelection().rangeCount > 0        // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0)     // Store selection if found
          : false;                                    // Mark as false to know no selection existed before
      el.select();                                    // Select the <textarea> content
      document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
      document.body.removeChild(el);
      if (selected) {                                 // If a selection existed before copying
        document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
        document.getSelection().addRange(selected);   // Restore the original selection
      }
      
      // Change popover text after clicking
      let popoverDiv = [...document.getElementsByClassName("popover-body")]
      // Get latest element hovered
      let lastPopoverDiv = popoverDiv[popoverDiv.length - 1]
      if (lastPopoverDiv) lastPopoverDiv.textContent = `Copied "${hexColourCode}" to clipboard`
    },
  }
}
</script>
